/**
 * Модульное состояние входа через платформу: памятка конфигурации и флаг «обмен начат».
 *
 * Оба значения обязаны пережить перемонтирование компонентов — в этом их смысл, — и
 * потому живут вне React. Отдельный модуль, а не поля рядом с компонентами: экспорт
 * не-компонента из файла с компонентом ломает fast refresh (eslint это и говорит), а
 * состояние всё равно общее для кнопки и страницы возврата.
 */

import { fetchSsoConfig, type SsoConfig } from '../../shared/api/client';

// Кнопка монтируется дважды на одном экране: гейт платформенного токена рисуется НАД
// формой логина (`DashboardRoute`). Конфигурация от этого не меняется, поэтому запрос
// один на загрузку страницы, а не один на кнопку. Пользовательских данных в ней нет
// (адрес платформы и код сервиса), сбрасывать её в `disposeModuleState` не за чем.
let configRequest: Promise<SsoConfig> | null = null;

export function loadSsoConfig(): Promise<SsoConfig> {
  if (!configRequest) {
    configRequest = fetchSsoConfig().catch((error) => {
      // Неудачу не кэшируем: следующий заход должен попробовать заново.
      configRequest = null;
      throw error;
    });
  }
  return configRequest;
}

export function resetSsoConfigCache(): void {
  configRequest = null;
}

/**
 * «Обмен кода уже начат» — защита от повторного монтирования страницы возврата.
 *
 * React в StrictMode прогоняет эффект дважды, а второй проход не найдёт ни кода (его
 * уже стёрли из адреса), ни `state` (он удалён из sessionStorage) — экран показал бы
 * ложную ошибку поверх успешного входа. Флаг именно модульный: в состоянии компонента
 * он обнулялся бы вместе с ним, то есть ровно тогда, когда нужен.
 */
let exchangeStarted = false;

export function beginSsoExchange(): boolean {
  if (exchangeStarted) return false;
  exchangeStarted = true;
  return true;
}

export function resetSsoExchangeGuard(): void {
  exchangeStarted = false;
}
